import { IBFBasalRate } from "@/lib/drivers/insulet/IBFHistoryLogs/IBF_BASAL_RATE";
import { IBFLogRecordHistory } from "@/lib/drivers/insulet/IBFRecords/IBF_LOG_RECORD";
import { OmnipodData } from "@/lib/drivers/insulet/OmnipodTypes";
import { OmnipodTransformer } from "@/lib/drivers/insulet/transformers/OmnipodTransformer";
import {
  IBGInterruptionEvent,
  getBasalRate,
  isBasalInterruptionEvent,
  isBasalRateEvent,
} from "@/lib/drivers/insulet/transformers/OmnipodTransformerUtils";
import { BasalRateChangeDTO } from "@/models/InsulinModel";

export class OmnipodBasalRateChangeTransformer implements OmnipodTransformer<BasalRateChangeDTO[]> {
  getBasalRateChangeEvents = (
    basalRateEvents: IBFLogRecordHistory<IBFBasalRate>[],
    basalDeliveryInterruptEvent: IBGInterruptionEvent[],
  ) => {
    const result: BasalRateChangeDTO[] = [];
    for (const event of basalRateEvents) {
      const basalRate = getBasalRate(event.history.data);
      result.push({
        sequence_id: event.logIndex,
        date: event.date.toISO() ?? "",
        basal_rate: basalRate.basalRate,
        base_basal_rate: basalRate.basalRate * basalRate.tempRatePercent,
        temp_rate: basalRate.tempRate,
        temp_rate_percent: basalRate.tempRatePercent,
      });
    }
    for (const event of basalDeliveryInterruptEvent) {
      result.push({
        sequence_id: event.logIndex,
        date: event.date.toISO() ?? "",
        basal_rate: 0,
        base_basal_rate: 0,
        temp_rate: false,
        temp_rate_percent: 1,
      });
    }
    return result;
  };

  transform = (data: OmnipodData): BasalRateChangeDTO[] => {
    const basalRateEvents = data.logs.filter(isBasalRateEvent);
    const basalRateInterruptionEvent = data.logs.filter(isBasalInterruptionEvent);
    return this.getBasalRateChangeEvents(basalRateEvents, basalRateInterruptionEvent);
  };
}
